import { createStandardAction } from 'typesafe-actions'
import { SubmissionStatus } from 'types/submissionStatus'

export const setCompleteness = createStandardAction('@contest/complete')<
  boolean
>()
export const submit = createStandardAction('@contest/submit')()
export const setSubmissionStatus = createStandardAction('@contest/submission')<
  SubmissionStatus
>()
